import { Storyboard } from '../../../shared/animations';
import { SummaryTabAnimations } from './AnimatedSummaryTab';

export class AnimatedSummaryTabState {
  animations: SummaryTabAnimations = new SummaryTabAnimations();
  show: () => Storyboard;
  hide: () => Storyboard;

  constructor() {
    const { show, hide } = this.animations;
    this.show = () => new Storyboard().append(0, show, [hide]);
    this.hide = () => new Storyboard().append(0, hide, [show]);
  }
}
